export const shouldInvalidatePage = (
  count: number,
  length: number,
  page: number,
  size: number
): boolean => {
  const remaining = count - length;
  const threshold = page * size + 1;
  const invalidatePage = remaining > 0 && remaining < threshold;

  return invalidatePage && page !== 0;
};

export const sanitizePhoneForTel = (phone: string) => {
  if (!phone) return '';

  const match = phone.match(/^(.*?)(?:\s*ext\.?\s*(\d+))?$/i);
  if (!match) return phone.trim();

  const base = match[1].trim();
  const ext = match[2] || '';

  return `${base}${ext}`;
};
